import { ErrorHandler, inject, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { ErrorDialogService } from './error-dialog.service';

const CHUNK_LOADING_PATTERNS = [
  /chunk-(.*?)\.js/,
  /Failed to fetch dynamically imported module/,
  /Loading chunk [\d]+ failed/,
];

@Injectable({
  providedIn: 'root',
})
export class CustomErrorHandler implements ErrorHandler {
  private readonly sentryErrorHandler = Sentry.createErrorHandler();
  private readonly errorDialogService = inject(ErrorDialogService);

  handleError(error: Error): void {
    // eslint-disable-next-line no-console
    console.error('Global error handler:', error);

    if (this.isChunkLoadingError(error)) {
      this.errorDialogService.openRefreshDialog();
      return;
    }

    this.sentryErrorHandler.handleError(error);
  }

  private isChunkLoadingError(error: Error): boolean {
    if (typeof error.message !== 'string') {
      return false;
    }
    if (!navigator.onLine) {
      return false;
    }
    const firstLine = error.message.split('\n')[0];
    return CHUNK_LOADING_PATTERNS.some((pattern) => pattern.test(firstLine));
  }
}
